<template>
  <el-input
    clearable
    v-model="contentValue"
    v-bind="$attrs"
    :size="formSize"
  >
    <el-select
      slot="prepend"
      placeholder="请选择"
      style="min-width: 140px"
      v-model="selectType"
      :size="formSize"
      :loading="loadingList"
    >
      <el-option
        v-for="item in selectOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </el-input>
</template>

<script>
export default {
  name: 'SearchInputSelect',
  props: {
    // 下拉选项
    options: {
      type: Array,
      default: () => ([]),
    },
    type: {
      type: [String, Number],
      default: '',
    },
    // 字典类型
    dictionaryType: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loadingList: false,
    };
  },
  computed: {
    selectOptions() {
      // 如果有静态的options，就不通过接口获取
      if (this.options.length > 0) {
        return this.options || [];
      }
      const { dictData = {} } = this.$store.state.dictionary;
      return dictData[this.dictionaryType] || [];
    },
    selectType: {
      get() {
        return this.type;
      },
      set(val) {
        this.$emit('update:type', val);
      },
    },
    contentValue: {
      get() {
        return this.content;
      },
      set(val) {
        this.$emit('update:content', val);
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      const { dictionaryType } = this;
      if (!dictionaryType) {
        console.log('没有字典');
      } else {
        // 获取字典
        this.loadingList = true;
        try {
          if (dictionaryType === '') return; // dictionaryType为空时,不请求
          this.$store.dispatch('dictionary/getDictionary', { type: dictionaryType });
        } finally {
          this.loadingList = false;
        }
      }
    },
  },
};
</script>

